import { Dispatch, SetStateAction } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { getUTMParameters } from '../../../../utils/cookieUtils';
import { sendGatedAssetData } from '../../../Common/GatedAsset/utils';

interface API_PROPS {
  formData: {
    email: string;
    phoneNumber: string;
  };
  setFormStatus: Dispatch<
    SetStateAction<{
      loading: boolean;
      success: boolean;
      error: string;
    }>
  >;
  recaptchaRef: React.RefObject<ReCAPTCHA>;
}

export const CallbackFormLead = async ({
  formData,
  setFormStatus,
  recaptchaRef,
}: API_PROPS) => {
  setFormStatus({ loading: true, success: false, error: '' });
  try {
    const chatData = {
      email: formData.email || '',
      phone_number: formData.phoneNumber || '',
      lead_source_url: window.location.href || '',
      form_type: 'partner-plan-selector-form',
      lead_type: 'partner-page',
      note: 'Lead from partner page',
      leadType: 'requestcallback-form',
      lead_source_page: window.location.href || '',
      lead_creation_time: Math.floor(new Date().getTime() / 1000),
      type_name: 'callbackRequest',
      ...getUTMParameters(),
    };

    const token = await recaptchaRef.current?.executeAsync();

    await sendGatedAssetData({
      formData: chatData,
      token: token as string,
    });

    setFormStatus({ loading: false, success: true, error: '' });
  } catch (err) {
    setFormStatus({
      loading: false,
      success: false,
      error: 'Error submitting form. Please try again.',
    });
    console.log('Error submitting form', err);
  }
};
